import * as React from 'react';
import { render } from 'react-dom';
import {
  CartApp,
  CheckoutApp,
  FailureApp,
  LangSwitcherApp,
  MembershipAccountApp,
  MembershipForgotApp,
  MembershipFormsApp,
  MembershipNavApp,
  MinicartApp,
  ReceiptApp } from './apps';
import { ICheckoutContextConfig } from './config/contextCheckoutConfig.d';
import createdStore from './store/store';
import { createRestInstance } from './utils/apiUtils';
import { getConfig, getDataAttributeValue } from './utils/utils';
// import { fetchSelection } from './reducers/checkout';

const URL = (window as Window).multistepCheckoutApiUrl || process.env.API_URL;
const PORT = (window as Window).multistepCheckoutApiPort || process.env.API_PORT;
const apiUrl = PORT ? `${URL}:${PORT}` : `${URL}`;

// Create axios rest instance
document.addEventListener('DOMContentLoaded', createRestInstance(apiUrl));

// Root react elements
const checkoutEl = document.getElementById('CheckoutMultiStep');
const minicartEl =
  (document.getElementById('CheckoutMultiStepMinicart') && [document.getElementById('CheckoutMultiStepMinicart')])
  || document.querySelectorAll('[data-js="multistep-minicart"]');
const cartEl = document.getElementById('CheckoutMultiStepCart');
const failureEl = document.getElementById('CheckoutMultiStepFailure');
const receiptEl = document.getElementById('CheckoutMultiStepReceipt');
const langSwitcherEl = document.getElementById('CheckoutMultiStepLangSwitcher');
const membershipFormsEl = document.getElementById('CheckoutMultiStepMembershipFormsApp');
const membershipNavEl = document.getElementById('CheckoutMultiStepMembershipNavApp');
const membershipAccountEl = document.getElementById('CheckoutMultiStepMembershipAccountApp');
const membershipForgotEl = document.getElementById('CheckoutMultiStepMembershipForgotApp');

if (checkoutEl !== null) {
  render(
    <CheckoutApp
      store={createdStore.store}
      persistor={createdStore.persistor}
      checkoutConfig={getConfig<ICheckoutContextConfig>(checkoutEl)}
    />,
    checkoutEl);
}

if (minicartEl !== null) {
  [].map.call(minicartEl, (el: HTMLElement) => {
    render(
      <MinicartApp
        store={createdStore.store}
        persistor={createdStore.persistor}
        cartLabel={getDataAttributeValue(el, 'label')}
      />, el);
  });
}

if (cartEl !== null) {
  render(
    <CartApp
      store={createdStore.store}
      persistor={createdStore.persistor}
      checkoutConfig={getConfig<ICheckoutContextConfig>(cartEl)}
    />, cartEl);
}

if (receiptEl !== null) {
  render(
    <ReceiptApp
      store={createdStore.store}
      persistor={createdStore.persistor}
      checkoutConfig={getConfig<ICheckoutContextConfig>(receiptEl)}
    />, receiptEl);
}

if (failureEl !== null) {
  render(
    <FailureApp
      store={createdStore.store}
      persistor={createdStore.persistor}
    />, failureEl);
}

if (membershipNavEl !== null) {
  render(
    <MembershipNavApp
      store={createdStore.store}
      persistor={createdStore.persistor}
      checkoutConfig={getConfig<ICheckoutContextConfig>(membershipNavEl)}
    />, membershipNavEl);
}

if (membershipFormsEl !== null) {
  render(
    <MembershipFormsApp
      store={createdStore.store}
      persistor={createdStore.persistor}
      checkoutConfig={getConfig<ICheckoutContextConfig>(membershipFormsEl)}
    />, membershipFormsEl
  );
}

if (membershipAccountEl !== null) {
  render(
    <MembershipAccountApp
      store={createdStore.store}
      persistor={createdStore.persistor}
      checkoutConfig={getConfig<ICheckoutContextConfig>(membershipAccountEl)}
    />, membershipAccountEl
  );
}

if (membershipForgotEl !== null) {
  render(
    <MembershipForgotApp
      store={createdStore.store}
      persistor={createdStore.persistor}
      checkoutConfig={getConfig<ICheckoutContextConfig>(membershipForgotEl)}
    />, membershipForgotEl
  );
}

if (langSwitcherEl !== null) {
  const languages = [
    {
      language: 'en',
      name: 'English',
    },
    {
      language: 'pl',
      name: 'Polish',
    },
    {
      language: 'sv',
      name: 'Swedish',
    },
    {
      language: 'no',
      name: 'Norwegian',
    },
    {
      language: 'de',
      name: 'German',
    },
    {
      language: 'fi',
      name: 'Finnish',
    },
    {
      language: 'fr',
      name: 'French',
    },
  ];

  render(
    <LangSwitcherApp
      store={createdStore.store}
      persistor={createdStore.persistor}
      languages={languages}
    />, langSwitcherEl);
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/index.tsx